import { BlockButton } from "../Button/BlockButton";
import { TextButton } from "../Button/TextButton";

// Google Icon SVG Component
const GoogleIcon = ({ className = "" }) => (
	<svg
		className={className}
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M17.64 9.20454C17.64 8.56636 17.5827 7.95272 17.4764 7.36363H9V10.845H13.8436C13.635 11.97 13.0009 12.9231 12.0477 13.5613V15.8195H14.9564C16.6582 14.2527 17.64 11.9454 17.64 9.20454Z"
			fill="#4285F4"
		/>
		<path
			d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5613C11.2418 14.1013 10.2109 14.4204 9 14.4204C6.65591 14.4204 4.67182 12.8372 3.96409 10.71H0.957275V13.0418C2.43818 15.9831 5.48182 18 9 18Z"
			fill="#34A853"
		/>
		<path
			d="M3.96409 10.71C3.78409 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40682 3.78409 7.83 3.96409 7.29V4.95818H0.957275C0.347727 6.17318 0 7.54773 0 9C0 10.4523 0.347727 11.8268 0.957275 13.0418L3.96409 10.71Z"
			fill="#FBBC05"
		/>
		<path
			d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z"
			fill="#EA4335"
		/>
	</svg>
);

// Globe Icon SVG Component
const GlobeIcon = ({ className = "", color = "currentColor" }) => (
	<svg
		className={className}
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75Z"
			stroke={color}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M1.25 10H18.75"
			stroke={color}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10 1.25C12.0747 3.50952 13.2483 6.45214 13.3094 9.53125C13.3706 12.6104 12.3156 15.5979 10.334 17.9375"
			stroke={color}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M10 1.25C7.92527 3.50952 6.75173 6.45214 6.69058 9.53125C6.62943 12.6104 7.68445 15.5979 9.66601 17.9375"
			stroke={color}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

// inJoy Logo SVG Component
const InJoyLogo = ({ className = "", color = "#B1B1B1" }) => (
	<svg
		className={className}
		xmlns="http://www.w3.org/2000/svg"
		width="54"
		height="12"
		viewBox="0 0 54 12"
		fill="none"
	>
		<path
			d="M10.6357 2.77051C12.8549 2.77053 14.6543 4.58576 14.6543 6.82422V12H11.9209V7.56738C11.9209 6.44815 11.0207 5.54004 9.91113 5.54004H4.5918V5.5293L7.32715 2.77051H10.6357ZM36.3896 0C39.0408 0 41.1904 2.16757 41.1904 4.8418V7.1582C41.1903 9.83231 39.0408 12 36.3896 12H34.0947C31.4437 11.9999 29.2951 9.83226 29.2949 7.1582V4.8418C29.2949 2.16761 31.4436 7.24125e-05 34.0947 0H36.3896ZM2.73535 11.999H0V2.76953H2.73535V11.999ZM7.3291 11.999H4.5918V6.75488H7.3291V11.999ZM27.4648 0V7.94531C27.4647 10.1836 25.6654 11.999 23.4463 11.999H16.4844L19.2188 9.24023L22.7207 9.22949C23.8302 9.22949 24.7304 8.32229 24.7305 7.20312V0H27.4648ZM48.9619 6.75586L48.9629 11.999H46.2285L46.2275 6.89551H46.2285L50.6904 0H54L48.9619 6.75586ZM34.4297 2.75879C33.1047 2.75882 32.0293 3.84316 32.0293 5.17969V6.82031C32.0294 8.15676 33.1047 9.24118 34.4297 9.24121H36.0547C37.3797 9.24121 38.455 8.15678 38.4551 6.82031V5.17969C38.4551 3.84314 37.3797 2.75879 36.0547 2.75879H34.4297ZM46.7891 3.26953L45.3213 5.53906L41.1904 0H44.5527L46.7891 3.26953Z"
			fill={color}
		/>
	</svg>
);

export const LoginPanel = ({
	logoSrc,
	title = "Login to inJoy Event",
	subtitle = "For venue teams managing sport events and reservations.",
	backgroundImage = "/img/login_bg.png",
	onGoogleLogin,
	language = "English",
	onLanguageChange,
	loading = false,
	error = null,
}) => {
	return (
		<div className="fixed inset-0 w-screen h-screen overflow-hidden z-50">
			{/* Desktop Layout */}
			<div className="hidden lg:flex w-full h-full">
				{/* Left Panel - Login Form */}
				<div className="flex-1 min-w-[400px] flex flex-col items-center justify-between bg-white py-10 px-5">
					{/* Main Content */}
					<div className="flex-1 flex flex-col items-start justify-center w-full max-w-[400px]">
						{/* Logo */}
						<div className="w-[75px] h-[75px] bg-color-Grey200 rounded mb-10">
							{logoSrc && (
								<img
									src={logoSrc}
									alt="Logo"
									className="w-full h-full object-contain"
								/>
							)}
						</div>

						{/* Title & Subtitle */}
						<div className="flex flex-col gap-3 mb-10 w-full">
							<h1 className="text-[28px] font-medium leading-[1.2] tracking-[-0.5px] text-color-Grey900">
								{title}
							</h1>
							<p className="text-[16px] leading-[1.4] tracking-[0.25px] text-color-Grey700">
								{subtitle}
							</p>
						</div>
						{error && (
							<div className="w-full mb-4 p-3 bg-color-Pink50 rounded">
								<p className="text-color_text_negative_4 text-sm">{error}</p>
							</div>
						)}

						<BlockButton
							type="Primary"
							width="400px"
							icon="google-icon"
							onClick={onGoogleLogin}
							disabled={loading}
						>
							{loading ? "Signing in..." : "Continue with Google"}
						</BlockButton>
					</div>

					{/* Footer */}
					<div className="flex flex-col items-center gap-8">
						{/* Language Selector */}
						<TextButton
							size="Large"
							type="Secondary"
							icon="global_outline"
							onClick={onLanguageChange}
						>
							{language}
						</TextButton>

						{/* Powered by */}
						<div className="flex items-center gap-[10px]">
							<span className="text-[12px] font-medium tracking-[1.5px] text-color-Grey500 uppercase">
								Powered by
							</span>
							<InJoyLogo color="#B1B1B1" />
						</div>
					</div>
				</div>

				{/* Right Panel - Background Image */}
				<div
					className="w-[41.6%] h-full rounded-l-2xl bg-cover bg-center relative overflow-hidden"
					style={{ backgroundImage: `url(${backgroundImage})` }}
				></div>
			</div>

			{/* Mobile/Tablet Layout */}
			<div
				className="lg:hidden w-full h-full flex flex-col bg-cover bg-center relative"
				style={{ backgroundImage: `url(${backgroundImage})` }}
			>
				{/* Content */}
				<div className="relative z-10 flex flex-col max-w-[400px] w-full h-full mx-auto px-5 py-10 safe-area-inset">
					{/* Top Section - Logo */}
					<div className="flex-1 flex items-center justify-center">
						<div className="w-[75px] h-[75px] bg-color-Grey200 rounded">
							{logoSrc && (
								<img
									src={logoSrc}
									alt="Logo"
									className="w-full h-full object-contain"
								/>
							)}
						</div>
					</div>

					{/* Bottom Section - Login Form */}
					<div className="flex flex-col items-center gap-10">
						{/* Title & Subtitle */}
						<div className="flex flex-col items-center gap-3 text-center">
							<h1 className="text-[28px] font-medium leading-[1.2] tracking-[-0.5px] text-white">
								{title}
							</h1>
							<p className="text-[16px] leading-[1.4] tracking-[0.25px] text-white max-w-[335px]">
								{subtitle}
							</p>
						</div>
						<div className="self-stretch">
							{error && (
								<div className="w-full mb-4 p-3 bg-color-Pink50 rounded">
									<p className="text-color_text_negative_4 text-sm">{error}</p>
								</div>
							)}

							<BlockButton
								type="Primary"
								width="100%"
								icon="google-icon"
								onClick={onGoogleLogin}
								disabled={loading}
							>
								{loading ? "Signing in..." : "Continue with Google"}
							</BlockButton>
						</div>

						{/* Powered by */}
						<div className="flex items-center gap-[10px]">
							<span className="text-[12px] font-medium tracking-[1.5px] text-white uppercase">
								Powered by
							</span>
							<InJoyLogo color="#FFFFFF" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export { GoogleIcon, GlobeIcon, InJoyLogo };
